"use client";

import { config } from "@fortawesome/fontawesome-svg-core";

config.autoAddCss = false;

export default function FontAwesomeConfig() {
  return null;
}
